import { render, staticRenderFns } from "./citizens.vue?vue&type=template&id=7cd4d204&"
import script from "./citizens.vue?vue&type=script&lang=js&"
export * from "./citizens.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports